export const CREATE_WP_TEMPLATE = 'CREATE_WP_TEMPLATE'

export const UPDATE_WP_TEMPLATE = 'UPDATE_WP_TEMPLATE'
